export enum RpFavTrackingEvents {
    CASINOGAMES = 'Casino Games',
    RECENTFAVOURITESTOGGLE = 'recent-favourites toggle',
    CLICK = 'click',
    MYGAMES = 'My Games',
    HOME = 'Home',
}

export enum TrackFavEvents {
    CATEGORYTYPE = 'CASINO',
    CATEGORYSUBTYPE = 'HOME',
}

export enum RpFavs {
    RECENTGAMES = 'recentgames',
    RECENT = 'recent',
    FAVOURITES = 'favourites',
}

export interface TrackingGameData {
    isFavourited?: boolean;
    gameLaunchedFrom?: string;
    gameTitle?: string;
    name?: string;
    gamePosition?: number;
    gameContainer?: string;
}
